{
  "Binary": "Бинар",
  "Calculation": "Калькуляция",
  "Compensation-Plan": "Комп. план",
  "Create-Account": "Создать аккаунт",
  "Dashboard": "Дашборд",
  "Document-Import": "Импорт документов",
  "Document-Registry": "Реестр документов",
  "Entire-Network": "Вся сеть",
  "Finance-Payouts": "Вывод средств",
  "Finance-Transactions": "Транзакции",
  "Finance-Wallet-Balances": "Балансы кошельков",
  "Finance-Wallet-Import": "Импорт кошельков",
  "Finance": "Финансы",
  "Genealogy": "Генеалогия",
  "Import-Tree": "Импорт дерева",
  "Logs": "Логи и отчеты",
  "Logs-Activity-Log": "Журнал активности",
  "Logs-Export-History": "История экспорта",
  "Logs-Reports": "Отчеты",
  "Manage-Accounts": "Управление аккаунтами",
  "Manage-Accounts-Roles": "Роли",
  "Manage-Accounts-Accounts": "Аккаунты",
  "Marketing-Activity": "Маркетинговая активность",
  "Network": "Сеть",
  "Payment-system": "Платежная система",
  "Profile": "Профиль",
  "Reports": "Отчеты",
  "Settings-Currencies": "Валюты",
  "Settings-Events": "События",
  "Settings-Event-Settings": "Настройки событий",
  "Settings-Wallets": "Настройки кошельков",
  "Settings-Payout-Methods": "Настройки вывода средств",
  "Settings-Localization": "Локализация",
  "Settings-Preferences": "Основные настройки",
  "Settings-Profile-Fields": "Настройки полей профиля",
  "Settings-Plan": "Настройки маркетингового плана",
  "Settings": "Настройки",
  "Visual-Binary": "Визуальный бинар",
  "Visual-Genealogy": "Визуальная генеалогия",
  "Visual-Tree": "Визуальное дерево",
  "Wallet": "Кошельки",
  "Settings-Wallet-Transfer-Rules": "Настройки правил перевода средств",
  "periodTypes": {
    "monthly": "Ежемесячно",
    "weekly": "Еженедельно",
    "daily": "Ежедневно",
    "hourly": "Ежечасно",
    "quarterHourly": "Каждые 15 минут",
    "yearly": "Ежегодно"
  }
}
